

















import Vue from 'vue';
import {Component} from 'vue-property-decorator';
// @ts-ignore
import Tools from "../helpers/Tools";
// @ts-ignore
import store from "../store";
import EventApi from "../api/EventsApi";
import {Player} from "../../types";

const TYPE_REACTION_LIKE = 1;
const TYPE_REACTION_UNLIKE = 2;

@Component({
    components: {},
    props: {}
})

export default class Reactions extends Vue {
    mounted(): void
    {
        this.bindEvents();
    }

    /**
     * Все игроки
     */
    private get players(): Array<Player>
    {
        return store.getters.getPlayers;
    }

    /**
     * События
     */
    private bindEvents()
    {
        $(document).keyup((e) => {
            if (store.getters.getPainterEditMode) {
                return;
            }

            // клик на Y
            if (e.keyCode === 89) {
                const focused = Tools.userFocusedOnInput();
                if (!focused) {
                    this.like();
                }
            }

            // клик на N
            if (e.keyCode === 78) {
                const focused = Tools.userFocusedOnInput();
                if (!focused) {
                    this.unlike();
                }
            }
        });
    }

    /**
     * Нравится
     */
    private like(): void
    {
        this.sendReaction(TYPE_REACTION_LIKE);
    }

    /**
     * Не нравится
     */
    private unlike(): void
    {
        this.sendReaction(TYPE_REACTION_UNLIKE);
    }

    /**
     * Отправить реакцию
     */
    private sendReaction(type: number)
    {
        this.$emit('reaction', type);
    }

    /**
     * Цвет игрока по id
     * @param playerId
     * @return {null|*}
     */
    getPlayerColor(playerId: string): string
    {
        let color = '';
        const filtered = this.players.filter(player => player.id === playerId);

        if (typeof filtered[0] !== 'undefined') {
            color = filtered[0].color.code;
        }

        return color;
    }

    /**
     * Реакция - нравится
     */
    private onLike(playerColor: string): void
    {
        const button = this.$refs.goodBtn as HTMLButtonElement;
        Tools.runTimer('reactionLikeButton', () => {
            this.clearButtonColor(button);
        }, 3000);
        this.changeButtonColor(button, playerColor);
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'like'});
    }

    /**
     * Реакция - не нравится
     */
    private onUnlike(playerColor: string): void
    {
        const button = this.$refs.badBtn as HTMLButtonElement;
        Tools.runTimer('reactionUnlikeButton', () => {
            this.clearButtonColor(button);
        }, 3000);
        this.changeButtonColor(button, playerColor);
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'dislike'});
    }

    /**
     * Очистить цвет кнопки
     * @param button
     */
    private clearButtonColor(button: HTMLButtonElement)
    {
        button.style.removeProperty('background');
        button.classList.remove('active');
    }

    /**
     * Изменить цвет кнопки
     * @param button
     * @param color
     */
    private changeButtonColor(button: HTMLButtonElement, color: string)
    {
        button.style.background = color;
        button.classList.add('active');
    }

    /**
     * Обработать реакцию
     */
    public processReaction(data: any)
    {
        const playerColor = this.getPlayerColor(data.userId);
        if (data.type === TYPE_REACTION_LIKE) {
            this.onLike(playerColor);
        } else {
            this.onUnlike(playerColor);
        }
    }
}

